module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [(_vm.row.bg_show) ? _c('div', {
    staticClass: "activity-detail-top"
  }, [_c('div', {
    staticClass: "top-info"
  }, [_c('div', {
    staticClass: "info-top-box"
  }, [_c('div', {
    staticClass: "activity-detail-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), (this.row.saiqu.id == 648) ? _c('div', {
    staticClass: "activity-detail-desc"
  }, [_vm._v("2024年全国啦啦操社区运动会将于2024年5月至11月以线上形式举行。")]) : _c('div', {
    staticClass: "activity-detail-desc"
  }, [_vm._v(_vm._s(_vm.row.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "info-main-box"
  }, [_c('div', {
    staticClass: "activity-dynamic"
  }, [_c('span', [_vm._v("动态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.bbs_content_count))]), _vm._v(" ·\n                  "), _c('span', [_vm._v("互动")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.bbs_activity_count))])]), _vm._v(" "), _c('div', {
    staticClass: "info-dynamic-items"
  }, [(_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiFilesList',
        query: {
          saiqu: _vm.row.type_id,
          type: 1
        }
      }),
      expression: "{name:'SaiFilesList',query:{saiqu:row.type_id,type:1}}"
    }],
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.visit('tongzhiwenjian')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("通知文件")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiFilesList',
        query: {
          saiqu: _vm.row.type_id,
          type: 2
        }
      }),
      expression: "{name:'SaiFilesList',query:{saiqu:row.type_id ,type:2}}"
    }],
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.visit('richengbiao')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-10@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("日程表")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.visit('baoming')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-8@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("立即报名")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiStartList',
        query: {
          saiqu: _vm.row.type_id
        }
      }),
      expression: "{name:'SaiStartList',query:{saiqu:row.type_id}}"
    }],
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.visit('shunxu')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-2@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("出场顺序")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiResult',
        query: {
          saiqu: _vm.row.type_id
        }
      }),
      expression: "{name:'SaiResult',query:{saiqu:row.type_id}}"
    }],
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        return _vm.visit('chengjichaxun')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-4@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("成绩查询")])]) : _vm._e(), _vm._v(" "), (_vm.row.type_id > 0) ? _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onShowShisu();
        _vm.visit('shisuanpai')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-9@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("食宿安排")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.saiqu.xinxihedui_open == 1),
      expression: "row.saiqu.xinxihedui_open==1"
    }],
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onInfoConfirm();
        _vm.visit('xinxihedui')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-xinxihedui.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("信息核对")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onResults();
        _vm.visit('chengjicexiazai')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-5@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("成绩册下载")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onZhixuce();
        _vm.visit('zhixucexiazai')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-6@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("秩序册下载")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onWenjuan();
        _vm.visit('diaocha')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-7@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("调查问卷")])]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item",
    on: {
      "click": function($event) {
        _vm.onZhibo();
        _vm.visit('zhibo')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/pic-shuo-3@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dynamic-item-title"
  }, [_vm._v("直播")])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "info-bottom-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-shuo-notice@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "height": "15px",
      "background": "rgba(0,0,0,1)",
      "opacity": "0.16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "start-immediately"
  }, [_vm._v("赛事马上开始咯~")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('van-tabs', {
    class: _vm.row.bg_show ? 'active-tab' : '',
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "type": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.row.list.list), function(item, i) {
      return _c('div', [(item.style == '-1') ? _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'NewsDetail',
            query: {
              id: item.id
            }
          }),
          expression: "{name:'NewsDetail',query:{id:item.id }}"
        }]
      }, [(item.pics.length == 0) ? _c('NewsItem1', {
        attrs: {
          "row": item
        }
      }) : _vm._e(), _vm._v(" "), (item.pics.length == 1) ? _c('NewsItem2', {
        attrs: {
          "row": item
        }
      }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (item.pics.length > 1) ? _c('NewsItem4', {
        attrs: {
          "row": item
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.style == '1') ? _c('Activity1', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '2') ? _c('Activity2', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '3') ? _c('Activity3', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '4') ? _c('Activity4', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '5') ? _c('Activity5', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (_vm.sendShow) ? _c('div', {
    staticClass: "comment-bottom"
  }, [_c('div', {
    staticClass: "send-comment"
  }, [_c('van-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-btn",
    on: {
      "click": _vm.onCommentSend
    }
  }, [_vm._v("发送")])], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('NavFloatAdd', {
    attrs: {
      "id": this.$route.query.id
    }
  }), _vm._v(" "), _c('NavFloatService', {
    on: {
      "show": function($event) {
        _vm.showKefu = true
      }
    }
  }), _vm._v(" "), _c('NavFloatShare', {
    on: {
      "show": function($event) {
        _vm.show_share_panel = true
      }
    }
  }), _vm._v(" "), _c('van-dialog', {
    model: {
      value: (_vm.showKefu),
      callback: function($$v) {
        _vm.showKefu = $$v
      },
      expression: "showKefu"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "10px auto",
      "font-size": "14px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.row.saiqu.erweiimg_pic_url
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 请添加赛事联系人微信")])]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "直播二维码",
      "show-confirm-button": false,
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showZhibo),
      callback: function($$v) {
        _vm.showZhibo = $$v
      },
      expression: "showZhibo"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "0px auto 20px",
      "font-size": "14px",
      "max-height": "400px",
      "overflow-y": "scroll"
    }
  }, [_c('p', [_vm._v("长按保存到相册")]), _vm._v(" "), _vm._l((_vm.row.saiqu.zhibo_pic_urls), function(imgrow, imgkey) {
    return _c('img', {
      key: imgkey,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "title": imgrow.name,
        "src": imgrow.url
      }
    })
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onZhiboDownload
    }
  }, [_vm._v("下载二维码")])], 2)]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "食宿安排",
      "show-cancel-button": "",
      "cancel-button-text": "我知道了",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.shisuShow),
      callback: function($$v) {
        _vm.shisuShow = $$v
      },
      expression: "shisuShow"
    }
  }, [_c('van-cell-group', {
    staticStyle: {
      "height": "8rem",
      "overflow-y": "scroll"
    }
  }, [_c('van-divider', [_vm._v("酒店信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "名称",
      "value": _vm.row.hotel.name ? _vm.row.hotel.name : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.row.hotel.address ? _vm.row.hotel.address : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "用餐",
      "value": _vm.row.hotel.dinner ? _vm.row.hotel.dinner : '暂未配置'
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("赛中车辆信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "车辆",
      "value": _vm.row.bus_list.name ? _vm.row.bus_list.name : '暂未配置'
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("接站信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "接站地点",
      "value": _vm.row.take_list.come_station_name ? _vm.row.take_list.come_station_name : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "接站时间",
      "value": _vm.row.take_list.come_date_time ? _vm.row.take_list.come_date_time : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "接站车次",
      "value": _vm.row.take_list.come_transcode ? _vm.row.take_list.come_transcode : '暂未配置'
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("送站信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "送站地点",
      "value": _vm.row.take_list.go_station_name ? _vm.row.take_list.go_station_name : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "送站时间",
      "value": _vm.row.take_list.go_date_time ? _vm.row.take_list.go_date_time : '暂未配置'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "送站车次",
      "value": _vm.row.take_list.go_transcode ? _vm.row.take_list.go_transcode : '暂未配置'
    }
  })], 1)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetActiveActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetCommentActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetCommentShow),
      callback: function($$v) {
        _vm.sheetCommentShow = $$v
      },
      expression: "sheetCommentShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  }), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a0cf03f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/activity/Activity.vue
// module id = 2289
// module chunks = 0